// extracted by mini-css-extract-plugin
export default {"resultsContainer":"PhoneOptions_resultsContainer__soSwq"};